import { Component, HostBinding } from '@angular/core';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError, NavigationCancel } from '@angular/router';
import { AuthService } from './users/auth.service';
import { EditGuard } from './shared/edit.guard';
import { slideInAnimation } from './app.animation';
import { Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';

@Component({
  selector: 'pm-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [slideInAnimation]
})
export class AppComponent {
  pageTitle = 'NC Business and Occupational License Database';
  metaTags = '';
  loading = true; 
  idleState = '';
  @HostBinding('@.disabled')
  public animationsDisabled = false; // Set to true to disable all animations

  
  get isLoggedIn(): boolean {
    return this.authService.isLoggedIn;
  }
  
  get userName(): string {
    if (this.authService.currentUser) {
      return this.authService.currentUser.userName;
    }
    return '';
  }

  get coordId(): number {
    if (this.authService.currentUser) {
      return this.authService.currentUser.id;
    }
    return null;
  }

  get isCoordinator(): boolean {
    if (this.authService.currentUser){
      return this.authService.currentUser.permLevel==2;
    }
    return false;
  }

  get isBlncAdmin(): boolean {
    if (this.authService.currentUser){
      return this.authService.currentUser.permLevel==3;
    }
    return false;
  }

  get isLeadAdmin(): boolean {
    if (this.authService.currentUser){
      return this.authService.currentUser.permLevel==4;
    }
    return false;
  }
 
  constructor(private authService: AuthService,
              private router: Router, private idle: Idle, private editGuard: EditGuard) {
    router.events.subscribe((routerEvent: Event) => {
      this.checkRouterEvent(routerEvent);
    });
    // https://github.com/moribvndvs/ng2-idle-example
    idle.setIdle(30*60);
    idle.setTimeout(30);
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {this.idleState = ''; this.idle.stop();});
    idle.onTimeout.subscribe(() => {
      this.editGuard.bypassMe=true;
      this.idleState = '';
      this.logOut();
     // this.editGuard.bypassMe=false;
    });
    idle.onTimeoutWarning.subscribe((countdown) => this.idleState = 'Your session will end in ' + countdown + ' seconds!');
    if (authService.isLoggedIn)   // NTS 23/04/27 return after leaving web site
      idle.watch();
  }

  checkRouterEvent(routerEvent: Event): void {
    if (routerEvent instanceof NavigationStart) {
      this.loading = true;
    }

    if (routerEvent instanceof NavigationEnd ||
        routerEvent instanceof NavigationCancel ||
        routerEvent instanceof NavigationError) {
      this.loading = false;
    }
  }

  login(): void {
    this.router.navigateByUrl('/login');
  }

  logOut(): void {
    this.authService.logout();
    this.router.navigateByUrl('/');  
  }

  publicStyle() : object {
    return this.authService.isLoggedIn  ? {'background-image':'none'} : {'background-image': 'url(/assets/images/modern-background.jpg)','height': '100%', 'background-position': 'center','background-attachment': 'fixed'} 
  }
}
